// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__31hJh","content":"styles_content__2zvQb","selectAll":"styles_selectAll__sXVPo"};